@if(isPageRestrictionLoaded) {
<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Good To Pay Invoices</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-invoice-filter [filterFields]="fields" (searchEvent)="onSearch($event)"
                        [pageId]="pageId"></ppl-invoice-filter>
                    <p class="pl-2"> <span class="error-message1">*</span> Atleast one out of the following fields
                        should be populated: <b>Participant Name</b>, <b>Participant PPL ID</b>, <b>Provider Name</b>,
                        <b>Provider PPL ID</b>.</p>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For the <strong>Deny</strong> action, please select the applicable invoice lines.</li>
                            <li>The <strong>Deny All</strong> action will deny every invoice line currently loaded in
                                the grid.</li>
                        </ul>
                    </div>
                </div>
                <div class="table-style">
                    @if(hasSearched) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="invoices" [customDataLoaded]="true"
                        [enableActions]="false" [from]="'invoices'"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)"
                        [actionButtons]="actionButtons" [enablePageActions]="!isReadOnly"
                        [badgeColumns]="['Application Status']"
                        [listButton]="isReadOnly ? [] : buttons" (actionInvoked)="gridAction($event)">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>
}

<ppl-popup-dialog [(isVisible)]="showActionPopup" [title]="title" [isOkText]="okText" (confirm)="handleOk()"
    (cancel)="handleCancel()" [showButtons]="true" [showOkButton]="false" [size]="'medium'" [position]="'center'">

    <form nz-form [formGroup]="invoiceActionForm">
        <!-- Remarks Field -->
        <div nz-row>
            <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-control>
                        <label for="remarks" class="field-header">Remarks</label>
                        <nz-textarea-count [nzMaxCharacterCount]="10000">
                            <textarea rows="3" nz-input id="remarks" formControlName="remarks"
                                placeholder="Start typing..." [maxlength]="10000"
                                [nzStatus]="invoiceActionForm.get('remarks')?.invalid && invoiceActionForm.get('remarks')?.touched ? 'error' : ''"></textarea>
                        </nz-textarea-count>
                        <div
                            *ngIf="invoiceActionForm.get('remarks')?.invalid && invoiceActionForm.get('remarks')?.touched">
                            <div class="error-message">Please enter remarks.</div>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>

</ppl-popup-dialog>

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p> This action will deny every invoice line currently loaded in the grid. Do you want to continue?</p>
    </ng-template>
</div>
